// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1936":"de8a21ea","6856":"feff1096"}[chunkId] + ".chunk.css";
};